import React from "react";
import i18n from "utils/i18n";
import _ from 'lodash'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form, { createTranslationField } from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import PreviewTimeslotKind from 'scenes/management/timeslots/timeslot_kind/_components/PreviewTimeslotKind'
import VStack from 'components/atoms/stack/VStack'
import HelperSetting from "utils/helper-setting";
import { settingsConstants } from "utils/constants/settings-constants";

const ManagementTimeslotKindBasicTab = ( { saveForm, updateTimeslotKind, timeslotKind, isSaving }) => {

	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const formFields = [
		{
			name: 'name',
			label: i18n.t('management:form.name.system_name'),
			type: FormFieldsConstants.TEXT,
		},
	];

	if( HelperSetting.isYes( settingsConstants.CREDITS_ENABLED ) ) {
		formFields.push({
			name: 'credit_amount',
			label: i18n.t('management:form.credit_amount.title'),
			type: FormFieldsConstants.NUMBER,
		});
	}
		
	formFields.push({
		name: 'active',
		label: i18n.t('management:form.active.title'),
		type: FormFieldsConstants.SELECT_ACTIVE
	});

	// Add the translations
	if( _.size( _languages ) > 0 ) {
		formFields.push( {
			type: FormFieldsConstants.DIVIDER
		} );
		
		// Add the translation fields
		_.forEach( _languages, ( language ) => {
			let { name, formField } = createTranslationField( 'name', language );
			formFields.push( formField );
			
			const { name: countName, formField: countFormField } = createTranslationField( 'count', language );
			formFields.push( countFormField );
			
			const { name: descriptionName, formField: descriptionFormField } = createTranslationField( 'description', language );
			formFields.push( descriptionFormField );
		});
	}
	
	return (
		<VStack>
			<PreviewTimeslotKind
				timeslotKind={ timeslotKind }
			/>
			
			<ThemedBlock
				shadow
				mediumPadding>
				
				<Form
					values={ timeslotKind }
					fields={ formFields }
					onChange={ updateTimeslotKind }
					onSubmit={ saveForm }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) || isSaving }
					forceSaveButton={ true }
				/>
			</ThemedBlock>
		</VStack>
	);
}


export default ManagementTimeslotKindBasicTab
